<div class="landing-page">
  <!-- Left Hero Panel with Curved Backdrop -->
  <div class="hero-panel">
    <div class="hero-backdrop"></div>
    <div class="hero-content">
      <div class="brand-logo">
        <svg class="mail-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        <span class="brand-title">{{ text.title }}</span>
      </div>

      <div class="action-box">
        <button type="button" class="btn-sign-in" (click)="onSignIn()">{{ text.loginButton }}</button>
      </div>
    </div>
  </div>

  <!-- Right Visual Graphics Panel -->
  <div class="graphic-panel" aria-hidden="true">
    <div class="isometric-illustration">
      <!-- Clean Mail / Workspace Graphic Elements -->
      <div class="graphic-card card-main">
        <div class="card-header">
          <span class="dot red"></span>
          <span class="dot yellow"></span>
          <span class="dot green"></span>
        </div>
        <div class="card-body">
          <div class="line long"></div>
          <div class="line medium"></div>
          <div class="chart-placeholder"></div>
        </div>
      </div>

      <div class="graphic-card card-envelope">
        <svg viewBox="0 0 24 24" fill="none" stroke="#0044cc" stroke-width="1.5">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
    </div>
  </div>
</div>